import { express, mui, propertysales } from '../../static'

export const projects = [
  // {
  //   img: "images/works/nextric-card.png",
  //   alt: "nextric web preview",
  //   title: "Nextric",
  //   desc:
  //     "Nextric is a demo of a full-stack social blogging platform. Authors can create content with their custom username and then post it publicly with SEO-friendly rendering, while readers can heart or like posts in real time.",
  //   techs: [
  //     { logo: "images/logos/logo-next-black.svg", alt: "next logo black" },
  //     { logo: "images/logos/logo-react.svg", alt: "logo react" },
  //     { logo: "images/logos/logo-firebase.svg", alt: "logo firebase" },
  //   ],
  //   getApp: "https://nextric-app.vercel.app/",
  //   github: "https://github.com/richidoes/social-blogging-platform",
  // },
  // {
  //   img: "images/works/pokedex-card.png",
  //   title: "Pokedex",
  //   alt: "pokedex web preview",
  //   desc:
  //     "Web application that shows us a list of pokemon brought from an external API (pokeapi.co).The registered user has access to the listing as well as other features like changing your profile picture and username.",
  //   techs: [
  //     { logo: "images/logos/logo-react.svg", alt: "logo react" },
  //     { logo: "images/logos/logo-redux.svg", alt: "logo redux" },
  //     { logo: "images/logos/logo-firebase.svg", alt: "logo firebase" },
  //   ],
  //   getApp: "https://pokedex-56112.web.app/",
  //   github: "https://github.com/richidoes/pokedex",
  // },
  // {
  //   img: "images/works/weather-card.png",
  //   title: "weather app",
  //   alt: "weather app preview",
  //   desc:
  //     "Weather Web application where we can request the current weather in a city,obtaining the data from an external API (openweathermap.org) and updating it on the screen.",
  //   techs: [{ logo: "images/logos/logo-react.svg", alt: "logo react" }],
  //   getApp: "https://weather-app9619.netlify.app/",
  //   github: "https://github.com/richidoes/weather-app",
  // },
  // {
  //   img: "images/works/place.png",
  //   title: "niceGDL",
  //   alt: "niceGDL screenshot",
  //   desc:
  //     "Mobile application for classification of places of interest that users publish and review about the city of Guadalajara, Jalisco.",
  //   techs: [
  //     { logo: "images/logos/logo-react.svg", alt: "logo react" },
  //     { logo: "images/logos/logo-firebase.svg", alt: "logo firebase" },
  //   ],
  //   getApp:
  //     "https://drive.google.com/uc?export=download&id=1Z6nrnc84_ahYE5pPNElijdNKn4UJaTpN",
  //   github: "https://github.com/richidoes/niceGDL",
  // },
  // {
  //   img: "images/works/course.png",
  //   title: "Courses app",
  //   alt: "",
  //   desc:
  //     "Mobile application that simulates a learning application, enjoy animations when registering, looking at settings, looking at notifications and more!",
  //   techs: [
  //     { logo: "images/logos/logo-react.svg", alt: "logo react" },
  //     { logo: "images/logos/logo-redux.svg", alt: "logo redux" },
  //     { logo: "images/logos/logo-graphql.svg", alt: "logo graphql" },
  //     { logo: "images/logos/logo-firebase.svg", alt: "logo firebase" },
  //   ],
  //   getApp:
  //     "https://drive.google.com/uc?export=download&id=1y8t2KOMlephV3SmAhRvc12Gbr9dpLX5Y",
  //   github: "https://github.com/richidoes/courses-app",
  // },

  {
    img: 'images/works/3dstore.png',
    title: '3D Product Store',
    alt: '3D Product Store preview',
    desc: "In this web store you can add custom color, file support, and even generate images through DALLE AI. All this to personalize your shirt and download the resulting t-shirt model image. Responsiveness across all devices, improve site's performance.",
    techs: [
      { logo: 'images/logos/logo-react.svg', alt: 'react logo.' },
      { logo: 'images/logos/threejs.svg', alt: 'threejs logo.' },
      { logo: 'images/logos/framermotion.png', alt: 'framermotion logo.' },
      { logo: 'images/logos/tailwind.png', alt: 'tailwind logo.' },
      { logo: 'images/logos/sass.svg', alt: 'sass logo.' },
      { logo: 'images/logos/css.png', alt: 'css logo.' },
    ],
    getApp: 'https://3d-product-store.vercel.app/',
    github: 'https://github.com/JesielPalacios/3d-product-website-frontend/',
  },

  {
    // img: 'https://raw.githubusercontent.com/JesielPalacios/3d-product-website-backend/main/assets/featured.png?token=GHSAT0AAAAAACA5KWZLI72LDRUQKZ3OUHAGZCANOMQ',
    img: 'images/works/3dstore.png',
    title: 'Product Store Back',
    alt: 'Product Store Back preview',
    desc: '3D Product Store backend server that prodive a Rest Full Gateway API, following Full MVC architecture, Proxy, Chain of Responsability, Singleton and many other design patterns and best practices. MongoDB database hosting service.',
    techs: [
      { logo: 'images/logos/node.png', alt: 'node logo.' },
      { logo: express, alt: 'express logo.' },
      { logo: 'images/logos/mongodb.png', alt: 'mondodb logo.' },
      { logo: 'images/logos/dalle.png', alt: 'dall.e logo.' },
      { logo: 'images/logos/cloudinary.png', alt: 'cloudinary logo.' },
    ],
    getApp: 'https://threed-product-store-backend.onrender.com/',
    github: 'https://github.com/JesielPalacios/3d-product-website-backend/',
  },

  {
    img: 'images/works/3dportfolio.png',
    title: '3D Porfolio',
    alt: '3D Porfolio preview',
    desc: 'Designed to showcase my work, achievements, expertise and skills to potential clients, employers. Allows users to see my work in a visually appealing and engaging manner providing a clear overview.',
    techs: [
      { logo: 'images/logos/logo-react.svg', alt: 'react logo.' },
      { logo: 'images/logos/threejs.svg', alt: 'threejs logo.' },
      { logo: 'images/logos/framermotion.png', alt: 'framermotion logo.' },
      { logo: 'images/logos/tailwind.png', alt: 'tailwind logo.' },
      { logo: 'images/logos/css.png', alt: 'css logo.' },
    ],
    getApp: 'https://3d-porfolio.vercel.app/',
    github: 'https://github.com/JesielPalacios/3d-porfolio/',
  },

  {
    img: propertysales,
    title: 'Property Sales',
    alt: 'Property Sales preview',
    desc: 'Comprehensive digital marketplace that connects buyers and sellers, providing them with tools, resources, and information to make informed decisions about the properties they are interested in.',
    techs: [
      { logo: 'images/logos/logo-react.svg', alt: 'react logo.' },
      { logo: mui, alt: 'mui logo.' },
      { logo: 'images/logos/css.png', alt: 'css logo.' },
    ],
    getApp: 'https://refine-dashboard-jesielvirtualsa.netlify.app/',
    github: 'https://github.com/JesielPalacios/refine_dashboard/',
  },

  {
    img: propertysales,
    title: 'Property Sales Back',
    alt: 'Property Sales Back preview',
    desc: 'Property Sales backend server that prodive a Rest Full Gateway API, following Full MVC architecture, Proxy, Chain of Responsability, Singleton and many other design patterns and best practices. MongoDB database hosting service.',
    techs: [
      { logo: 'images/logos/node.png', alt: 'node logo.' },
      { logo: express, alt: 'express logo.' },
      { logo: 'images/logos/mongodb.png', alt: 'mondodb logo.' },
      { logo: 'images/logos/cloudinary.png', alt: 'cloudinary logo.' },
    ],
    getApp: 'https://refine-dashboard-jesielvirtualsa.netlify.app/',
    github: 'https://github.com/JesielPalacios/refine_dashboard/',
  },

  {
    img: 'images/works/portfolio.png',
    title: 'Porfolio',
    alt: 'Porfolio preview',
    desc: 'Designed to showcase my work, achievements, expertise and skills to potential clients, employers. Allows users to see my work in a visually appealing and engaging manner providing a clear overview.',
    techs: [
      { logo: 'images/logos/logo-react.svg', alt: 'react logo.' },
      { logo: 'images/logos/gatsby-logo.svg', alt: 'gatsby-logo logo.' },
      {
        logo: 'images/logos/styled-components.png',
        alt: 'styled-components logo.',
      },
      { logo: 'images/logos/css.png', alt: 'css logo.' },
    ],
    getApp: 'https://jesielpalacios.github.io/',
    github: 'https://github.com/JesielPalacios/portfolio/',
  },

  {
    img: 'images/works/rickandmorthy.png',
    title: 'Rick&MortyPedia',
    alt: 'Rick&MortyPedia preview',
    desc: 'Rick&MortyPedia App consuming (rickandmortyapi.com) Rest Full API. You will be able to see all the characters listed, as well as detailed information on each character, and detailed information on all the locations and their residents.',
    techs: [
      { logo: 'images/logos/angular.png', alt: 'react logo.' },
      { logo: 'images/logos/bootstrap.png', alt: 'bootstrap logo.' },
      { logo: 'images/logos/css.png', alt: 'css logo.' },
    ],
    getApp: 'https://rick-and-morty-pedia.vercel.app/',
    github: 'https://github.com/JesielPalacios/rick-and-morty-pedia/',
  },

  {
    img: 'images/works/shopping-cart.png',
    title: 'Shopping Cart App',
    alt: 'Shopping Cart App preview',
    desc: 'Shopping Cart Web App that shows us a list of products brought from an external API (fakestoreapi.com). Products can be added to a shopping cart in which the total amount is calculated according to the number of products.',
    techs: [
      { logo: 'images/logos/logo-react.svg', alt: 'react logo.' },
      {
        logo: 'images/logos/styled-components.png',
        alt: 'styledcomponents logo.',
      },
    ],
    // getApp: 'https://react-shopping-cart-2021.herokuapp.com/',
    getApp: 'https://react-shopping-cart-2021.vercel.app/',
    github: 'https://github.com/JesielPalacios/react-shopping-cart',
  },

  {
    img: 'images/works/calculadorapp-binaria.png',
    // https://camo.githubusercontent.com/dc130e15e764a2ce83daf7503c9b73e5ee349259ceb82b4a0f393339289f8564/68747470733a2f2f63646e2d696d616765732d312e6d656469756d2e636f6d2f6d61782f313230302f312a352d616f4b3849426d58766535776842514d393047412e706e67
    title: 'CalculadorApp',
    alt: 'calculadora app preview',
    // desc: 'Es una app móvil que permite realizar conversiones numéricas simultaneamente entre números decimales, binarios, octales y hexadecimales. Suma, resta y operaciones lóicas (AND, OR, XOR) de números binarios.',
    desc: "CalculadorApp binary it's a mobile application that allows us simultaneous numerical conversions between decimal, binary, octal and hexadecimal numbers. Addition, subtraction and logical operations (AND, OR, XOR) of binary numbers.",
    techs: [
      {
        logo: 'images/logos/flutter-logo.svg',
        alt: 'logo de framework para frontend: flutter como tecnología utilizada para esta app web.',
      },
    ],
    getApp:
      'https://drive.google.com/file/d/1G4WMdC2TRFQPc-hs6r94iM5HejeTQa7g/view',

    // 'https://drive.google.com/uc?export=download&id=1RvaWgbkXXzpEIrup0xNinnKTVqZqxH-x',

    // 'https://drive.google.com/uc?export=download&id=1G4WMdC2TRFQPc-hs6r94iM5HejeTQa7g',

    github: 'https://github.com/JesielPalacios/calculadorapp-binaria',
  },
]
